import { AuthAction, AuthState } from './authTokenActions';

export const initialState: AuthState = {
    error: null,
    loading: false,
    user: null,
    token: '',
    isAuthenticated: false,
    authMode: 'auth0',
};

export const authReducer = (state: AuthState = initialState, action: AuthAction): AuthState => {
    switch (action.type) {
        case 'START_AUTH':
            return { ...state, loading: true, error: null };
        case 'SUCCESS_AUTH':
            return {
                ...state,
                loading: false,
                user: action.user,
                token: action.token,
                isAuthenticated: true,
                authMode: action.authMode,
            };
        case 'FAIL_AUTH':
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};
